import { Component, h, Prop, State, Watch } from '@stencil/core';
import { User } from '../../../../icons';

@Component({
  tag: 'ugc-review-avatar',
  shadow: false,
})
export class UgcReviewAvatar {
  @Prop() customerProfileLink: string = '';
  @Prop() profileImageUrl: string = '';
  @Prop() size?: string = '48';
  @State() isInvalidProfileImage: boolean = false;

  @Watch('profileImageUrl')
  watchProfileImageHandler() {
    this.isInvalidProfileImage = false;
  }

  @Watch('customerProfileLink')
  watchProfileLinkHandler() {
    this.isInvalidProfileImage = false;
  }

  render() {
    return this.isInvalidProfileImage ? (
      <a href={`/me/${this.customerProfileLink}`} class="flex-row-start-start inherit">
        <span
          class="flex-row-center-center p-8 rounded-50 bg-gray-300"
          style={{ width: `${this.size}px`, height: `${this.size}px` }}
        >
          <User width="24" height="24" />
        </span>
      </a>
    ) : (
      <div class="flex-row-center-center">
        <a href={`/me/${this.customerProfileLink}`} class="inherit">
          <img
            src={this.profileImageUrl}
            alt=""
            style={{ width: `${this.size}px`, height: `${this.size}px` }}
            class="rounded-50"
            onError={() => {
              this.isInvalidProfileImage = true;
            }}
          />
        </a>
      </div>
    );
  }
}
